module.exports = __webpack_public_path__ + "media/icons/search-green-48px-4be8aa97.png";